import { render, staticRenderFns } from "./NmcCheck.vue?vue&type=template&id=94510dfc"
import script from "./NmcCheck.vue?vue&type=script&lang=js"
export * from "./NmcCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports